import { render, staticRenderFns } from "./LuPriority.vue?vue&type=template&id=3c669c47"
import script from "./LuPriority.vue?vue&type=script&lang=js"
export * from "./LuPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports